import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';
import {
  getWorkOrderByGuid,
  getWorkOrdersStickerByToken,
} from './QRCode.service';

export function useWorkOrderByGuid(guid: string) {
  const query = useQuery(
    ['detail-workOrder-qrCode', guid],
    () => getWorkOrderByGuid(guid),
    { enabled: !!guid },
  );

  useServiceError(query.error);

  return query;
}

export function useWorkOrdersStickerByToken(token: string) {
  const query = useQuery(
    ['detail-workOrder-qrCode', token],
    () => getWorkOrdersStickerByToken(token),
    { enabled: !!token },
  );

  useServiceError(query.error);

  return query;
}
